import { useQuery } from 'react-query';
import { publicGrammarService } from '../../shared/apis/client';
import { landingGrammarUrls } from '../../shared/apis/api-urls';
import { GrammarTemplateTypeEnum } from '../../shared/constants';

export const postElasticSearchResult = async (payload) => {
  const { data } = await publicGrammarService.post(
    landingGrammarUrls.GET_ELASTIC_SEARCH_MULTI_SEARCH,
    payload
  );
  return data;
};

export const getElasticSearchResult = async () => {
  const { data } = await publicGrammarService.get(
    landingGrammarUrls.GET_ELASTIC_SEARCH_MOST_POPULAR
  );
  return data;
};

export const useGetRecommendsSearch = ({ enabled }) => {
  return useQuery<any>(['getElasticSearchResult'], () => getElasticSearchResult(), { enabled });
};

export const useGetResultsFilterByType = ({ value, pageCurrent, size, enabled }) => {
  const { data } = useQuery<any>(
    ['postElasticSearchResult', value, pageCurrent, size],
    () =>
      postElasticSearchResult({
        queries: [
          {
            query: value,
            filters: {
              template_type_id: [GrammarTemplateTypeEnum.BLOG_GRAMMAR_THEORY],
            },
            page: {
              size,
              current: pageCurrent,
            },
          },
          {
            query: value,
            filters: {
              template_type_id: [GrammarTemplateTypeEnum.BLOG_GRAMMAR_EXERCISE],
            },
            page: {
              size,
              current: pageCurrent,
            },
          },
        ],
      }),
    {
      enabled,
    }
  );

  return {
    searchTheories: data?.[0]?.results,
    searchExercises: data?.[1]?.results,
    emptyTheories: data?.[0]?.results?.length === 0,
    emptyExercises: data?.[1]?.results?.length === 0,
  };
};
